import { Box, Button, Grid, Stack } from '@mui/material';
import { useState } from 'react';
import { TitlePages } from '@/components/Base/TitlePage';
import KpiComponent from '@/components/Base/KpiComponent';
import PeriodFilterDash from '@/components/Base/PeriodFilterDash';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import TableBasicRankRaio from '@/components/Base/TableBasicRankRaio';
import RankingComponent from '@/components/Base/RankingComponent';
import { getIpcaEntradaSaidaAlunos } from './api/getIpcaEntradaSaidaAlunos';
import { useRaioxAlunos } from '../raiox-alunos/api/getRaioxAlunos';
import LoadingSummary from './components/LoadingSummary';
import LoadingChart from './components/LoadingChart';

const RaioX = () => {
  const generateLastYears = (numYears) => {
    const currentYear = dayjs().year();
    return Array.from({ length: numYears }, (_, index) => currentYear - index).reverse();
  };
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);

  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [listYears, setListYears] = useState(generateLastYears(5));

  const daysDiff = dayjs(selectedEndDate).diff(dayjs(selectedStartDate), 'day') || null;

  const filters = {
    ...(selectedYear && { year: selectedYear }),
    ...(selectedMonth && { month: selectedMonth }),
    ...(selectedStartDate && { startDate: selectedStartDate }),
    ...(selectedEndDate && { endDate: selectedEndDate }),
  };

  const { data: dataAlunos, isFetched, isFetching } = useRaioxAlunos(filters);

  return (
    <>
      <>
        <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
          <TitlePages title={'Alunos'} />
        </Stack>

        <Box
          padding={'15px'}
          sx={{
            border: '1px solid rgba(176, 176, 176, 1)',
            background: '#fff',
            borderRadius: '14px',
          }}
        >
          {isFetching && <LoadingSummary />}
          {dataAlunos?.kpis && (
            <Stack flexDirection={'row'} gap={'8px'}>
              <Stack
                flexDirection="row"
                maxWidth="100%"
                gap="8px"
                style={{
                  overflowX: 'auto',
                  scrollBehavior: 'smooth',
                  scrollbarWidth: 'thin',
                  scrollbarColor: '#E04A4C #f1f1f1',
                }}
              >
                <KpiComponent title={'Maior score médio '} 
                  value={dataAlunos.kpis.highestAverageScore} 
                  // value={"10"}
                />
                <KpiComponent title={'Maior score financeiro'} 
                  value={dataAlunos.kpis.highestFinancialScore} 
                  // value={"10"}
                />
                <KpiComponent title={'Maior score frequência'} 
                  value={dataAlunos.kpis.highestFrequencyScore} 
                  // value={"10"}
                />
                <KpiComponent title={'Maior score pedagógico'} 
                  value={dataAlunos.kpis.highestPedagogicalScore} 
                  // value={"10"}
                />
              </Stack>
            </Stack>
          )}
          <Box marginTop={'10px'} marginBottom={'25px'}>
            <PeriodFilterDash
              startDate={selectedStartDate}
              endDate={selectedEndDate}
              onStartDateChange={setSelectedStartDate}
              onEndDateChange={setSelectedEndDate}
              refetchDashboard={() => console.log('teste')}
              listYears={listYears}
              setSelectedYear={setSelectedYear}
              setSelectedMonth={setSelectedMonth}
              selectedYear={selectedYear}
              showPeriodFilter={false}
              selectedMonth={selectedMonth}
            />
          </Box>
          <Stack flexDirection={'row'} gap={'30px'}>
            <Box width={'50%'} flex={1}>
              <LoadingChart loading={isFetching} />
              {dataAlunos?.tableAlunos && <RankingComponent data={dataAlunos.tableAlunos.slice(0, 3)} />}
            </Box>
            <Box width={'50%'} flex={1}>
              <LoadingChart loading={isFetching} />
              {dataAlunos?.tableAlunos && <TableBasicRankRaio data={dataAlunos.tableAlunos} />}
            </Box>
          </Stack>
        </Box>
      </>
    </>
  );
};

export default RaioX;
